//
//
//
//


export default {
  name: "comicobject",
  data() {
    return {
      comic_data: undefined,
    }
  },
  methods: {
    get_chapter_title: function (comic_data, chapter) {
      var ichapter = parseInt(chapter) - 1;
      var ptitle = '';
      var photo_title = comic_data.photo_title;
      if (photo_title && photo_title[ichapter + ""]) {
        ptitle = photo_title[ichapter + ""];
      } else {
        ptitle = "第" + chapter + "话"
      }
      return ptitle
    },
    load_comic_hisotry_list: function ({uid, with_data = true, start, limit, cb, error_cb}) {
      this.$axios.get("/app/comic/history", {
        params: {
          'start': start,
          'limit': limit,
          'with_data': with_data,
          'uid': uid
        }
      }).then((response) => {
        if (cb) {
          cb(response.data)
        }
      }).catch((e) => {
        if (error_cb) {
          error_cb(e)
        }
      })
    },
    load_comic_star_list: function ({uid, with_data = true, start, limit, cb, error_cb}) {
      this.$axios.get("/app/comic/star", {
        params: {
          'start': start,
          'limit': limit,
          'with_data': with_data,
          'uid': uid
        }
      }).then((response) => {
        if (cb) {
          cb(response.data)
        }
      }).catch((e) => {
        if (error_cb) {
          error_cb(e)
        }
      })
    },
    load_comic_buy_list: function ({uid, with_data = true, start, limit, cb, error_cb}) {
      this.$axios.get("/app/comic/buy", {
        params: {
          'start': start,
          'limit': limit,
          'with_data': with_data,
          'uid': uid
        }
      }).then((response) => {
        if (cb) {
          cb(response.data)
        }
      }).catch((e) => {
        if (error_cb) {
          error_cb(e)
        }
      })
    },
    get_comic_datas: function ({country, start, limit, cb, error_cb}) {
      this.$axios.get("/app/comic/list", {
        params: {
          'country': country,
          'start': start,
          'limit': limit
        }
      }).then((response) => {
        if (cb) {
          cb(response.data)
        }
      }).catch((e) => {
        if (error_cb) {
          error_cb(e)
        }
      })
    },
    watch_chapter: function ({id, watch_chapter}) {
      if (!this.$store.state.hasLogin) {
        return;
      }
      var params = {
        'id': id,
        'watch_chapter': watch_chapter
      };
      this.$axios.post("/app/watch/comic", params).then((response) => {

      }).catch((error) => {

      });
    },
    load_comic_data: function ({id, watch_chapter = false, tabinfo = false}) {
      if (this._g.comic_datas[id]) {
        if (watch_chapter) {
          this.watch_chapter({id, watch_chapter})
        }
        return this.on_comic_data_change(this._g.comic_datas[id]);
      }
      if (this.comic_data && this.comic_data.id == id) {
        if (watch_chapter) {
          this.watch_chapter({id, watch_chapter})
        }
        return this.on_comic_data_change(this.comic_data);
      }

      var params = {};
      if (watch_chapter) {
        params['watch_chapter'] = watch_chapter;
      }

      if (tabinfo) {
        params['tabinfo'] = tabinfo;
      }

      this.$axios.get("/app/comic/" + id,
        {
          params: params
        }).then((response) => {
        console.log("response:", response)
        this._g.comic_datas[id] = this.comic_data = response.data;
        this.on_comic_data_change(this.comic_data);
      }).catch((error) => {
        console.log("error", error)
        this.on_comin_data_error(id, error)
      });
    },
    on_comic_data_change: function (comic_data) {
      console.log('on_comin_data_change:', comic_data);
    },
    on_comin_data_error: function (id, error) {

    },
    load_tabinfo: function (id) {
      if (this._g.tabinfos[id]) {
        console.log("from tabinfos: ", id);
        return this.on_tabinfo_change(this._g.tabinfos[id])
      }
      this.$axios.get("/app/comic/tabinfo", {
        params: {
          'id': id
        }
      }).then((response) => {
        this._g.tabinfos[id] = response.data;
        this.on_tabinfo_change(this._g.tabinfos[id])
      }).catch((error) => {
        console.log("error", error)
      });
    },
    on_tabinfo_change: function (tabinfo) {
      console.log('on_tabinfo_change:', tabinfo);
    },
    get_manhua_by_country: function (c) {
      for (var i = 0; i < this.$manhua_conf.list.length; ++i) {
        var manhua_conf = this.$manhua_conf.list[i];
        if (parseInt(c) == manhua_conf['country']) {
          return manhua_conf;
        }
      }
    },
    compute_total_chapter: function (comic_data) {
      var chapter_list = [];
      var photo_object = comic_data.photo_object;
      var photo_title = comic_data.photo_title;

      for (let k in photo_object) {
        if (!isNaN(parseInt(k))) {
          var t_title = '';
          if (photo_title && photo_title[k]) {
            t_title = photo_title[k];
          }
          chapter_list.push([
            k, photo_object[k], t_title
          ]);
        }
      }
      return chapter_list;
    },
    do_comic_list: function (comic_list, ROW_COUNT, full_row = false) {
      var row_count = ROW_COUNT;
      var datas = comic_list;
      let comic_rows = []
      for (var i = 0; i < datas.length; i += row_count) {
        var row_datas = [];
        for (var r = 0; r < row_count; r++) {
          if (datas[i + r]) {
            row_datas.push(datas[i + r]);
          } else {
            if (!full_row) {
              row_datas.push({});
            }
          }
        }
        if (full_row && row_datas.length < row_count) {
          continue;
        }
        comic_rows.push(row_datas)
      }
      return comic_rows;
    },
    generate_chapter_list: function (comic_data) {
      var chapter_list = [];
      var photo_title = comic_data.photo_title;
      for (let chapter in comic_data.photo_object) {
        var ichapter = parseInt(chapter) + 1
        this.last_chapter = Math.max(this.last_chapter, ichapter)
        if (photo_title && photo_title[chapter]) {
          chapter_list.push({
            'title': photo_title[chapter],
            'chapter': ichapter
          })
        } else {
          if (!isNaN(ichapter)) {
            var title = "第" + ichapter + "话";
            chapter_list.push({
              'title': title,
              'chapter': ichapter
            })
          }
        }
      }
      return chapter_list
    },
    get_chapter_photo_list: function (comic_data, chapter) {
      var current_photo_list = comic_data.photo_object[(parseInt(chapter) - 1) + ""];
      return current_photo_list
    },
    is_need_buy: function (comic_data, chapter) {
      var buy_chapter_conf = comic_data.buy_chapter_conf;
      var pay_chapters = buy_chapter_conf.pay_chapters;
      if (Array.isArray(pay_chapters) && pay_chapters.indexOf(parseInt(chapter)) >= 0) {
        return true;
      }
      return false;
    },
    is_bought: function (tabinfo, chapter) {
      var comic_buy = tabinfo.comic_buy;
      if (comic_buy) {
        if (comic_buy.chapter_list && Array.isArray(comic_buy.chapter_list)) {
          if (comic_buy.chapter_list.indexOf(chapter) >= 0)
            return true;
        }
      }
      return false;
    },
    show_buy_dialog: function () {

    }
  }
}
